import * as storeNS from '@/store/namespace';
import * as NS from './namespace';
import { ActionContext } from 'vuex';
import { SidebarItem } from 'vue-sidebar-menu';

const actions: NS.ISidebarActions = {
    async setIsOpen({ commit, state }: ActionContext<NS.ISidebarState, storeNS.IState>, payload: boolean) {
        commit('SET_IS_OPEN', payload);
    },
    async loadMenu({ commit, state }: ActionContext<NS.ISidebarState, storeNS.IState>, payload: any) {
        commit('SET_MENU_REQUEST');

        try {
            // общие пункты меню
            const userMenu: Array<SidebarItem> = [
                {
                    href: '/',
                    title: 'Просмотр',
                    icon: {
                        element: 'b-icon-tv',
                        class: '',
                    },
                    child: [
                        {
                            href: '/tables',
                            title: 'Таблицы',
                            icon: {
                                element: 'b-icon-card-list',
                                class: '',
                            }
                        },
                        {
                            href: '/graphs',
                            title: 'Графики',
                            icon: {
                                element: 'b-icon-graph-up',
                                class: '',
                            }
                        },
                        {
                            href: '/excel',
                            title: 'Экспорт в Excel',
                            icon: {
                                element: 'b-icon-table',
                                class: '',
                            }
                        },
                        {
                            href: '/about',
                            title: 'О программе',
                            icon: {
                                element: 'b-icon-info-circle',
                                class: '',
                            }
                        },
                    ],
                },
            ];
            // пункты меню администратора
            const adminPart: Array<SidebarItem> = [
                {
                    href: '/administration',
                    title: 'Администрирование',
                    icon:  {
                        element: 'b-icon-gear-fill',
                        class: '',
                    },
                    child: [
                        {
                            href: '/administration/devices',
                            title: 'Устройства',
                            icon: {
                                element: 'b-icon-diagram3-fill',
                                class: '',
                            }
                        },
                        {
                            href: '/administration/indicators',
                            title: 'Показатели',
                            icon: {
                                element: 'b-icon-pencil-square',
                                class: '',
                            }
                        },
                        {
                            href: '/administration/users',
                            title: 'Пользователи',
                            icon: {
                                element: 'b-icon-people-fill',
                                class: '',
                            }
                        }
                    ]
                }
            ];
            commit('SET_MENU_SUCCESS', { user: userMenu, admin: userMenu.concat(adminPart) } );
        } catch (error) {
            commit('SET_MENU_FAIL', error);
        }
    },
}

/**
 * Реализация действий модуля сайдбара
 */
export default actions;